<div class="container-fluid main-container">
  <!--  <div class="aside-wrapper">
        <app-aside></app-aside>
    </div>-->
    <header class="main-header-wrapper">
        <app-dam-header></app-dam-header>
    </header>
    <app-active-filters-bar></app-active-filters-bar>
    <router-outlet />
    <app-asset-detail></app-asset-detail>
    <app-upload></app-upload>
    <app-pdf-viewer></app-pdf-viewer>
</div>
